import { render, staticRenderFns } from "./OrderItemInput.vue?vue&type=template&id=8e30a360&scoped=true&"
import script from "./OrderItemInput.vue?vue&type=script&lang=js&"
export * from "./OrderItemInput.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemInput.vue?vue&type=style&index=0&id=8e30a360&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e30a360",
  null
  
)

export default component.exports